import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_AUDITTRACEDETAILS_INIT_ACTION,
  FETCH_AUDITTRACEDETAILS_SUCCESS_ACTION,
  FETCH_AUDITTRACEDETAILS_FAIL_ACTION
} from "./action";

import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var btoa = require("Base64").btoa;
var history = createBrowserHistory();


function* fetchAuditTrace(value) {
  const token = localStorage.getItem("token");
  let pageno = value.value === undefined ? 1 : value.value;

  try {
    const res = yield fetch(
      `${appConfig.ip}/auditTrail?limit=10&page=` + pageno,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      console.log(resJSON);
      yield put({
        type: FETCH_AUDITTRACEDETAILS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_AUDITTRACEDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* AuditTraceActionWatcher() {
  yield takeEvery(FETCH_AUDITTRACEDETAILS_INIT_ACTION, fetchAuditTrace);
}
